// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3d9iP","label":"styles_label__3_DwW"};